import { getGuidesPageUrl } from "../../../utils/urls"
import * as ImageConstants from "../../../constants/images"
import moment from "moment"
import { Card } from "react-bootstrap"
import { LocalizedGuides } from "../../../types/guides"
import { TextButtonWithoutAnchor } from "@components/UI/TextButtonWithoutAnchor"

export default function GuidesList({
  guides,
}: {
  guides: LocalizedGuides[]
  showHeader?: boolean
  headerTitle?: string
}) {
  return (
    <>
      {guides.length > 0
        ? guides.map((n, i: number) => {
            i = i + 1
            return (
              <>
                <div style={{ marginTop: "20px" }}>
                  <Card
                    style={{
                      borderRadius: "5%",
                      backgroundColor: "#F5F5F5",
                      padding: 0,
                      // minHeight: "420px",
                      borderColor: "#FFFFFF",
                    }}
                  >
                    <img
                      src={n?.image?.path || ImageConstants.NEWS_MISSING_IMAGE_PATH}
                      alt={n.title}
                      style={{ borderRadius: "5% 5% 0 0", minHeight: "200px" }}
                    />
                    <div className={"card-body"}>
                      {/* <h3 className={"news-headline"}>{n.title}</h3>
                      <div className={"guide-description"}>{n.description}</div>
                      <div className={"guide-list-date-div"}>{n && moment(n.publishedAt).format("DD/MM/YYYY")}</div> */}
                    </div>
                    <div style={{ marginBottom: "20px", padding: "0 20px", marginTop: "20px" }}>
                      <TextButtonWithoutAnchor
                        text={"Vai alla guida"}
                        href={getGuidesPageUrl(n.calciocomSlug!)}
                        key={i}
                      />
                    </div>
                  </Card>
                </div>
              </>
            )
          })
        : "Al momento non ci sono news disponibili"}
    </>
  )
}
